import React, { useEffect } from 'react';
import './ConfirmModal.css';

// A FORM IN THE DIALOG: pass formId (the id of a <form> in children) and the confirm button submits that form, so
// the browser's required-field checks run and the form's onSubmit does the work — onConfirm is then not called.
// wide gives a larger, scrolling dialog for a form; closeOnBackdrop=false keeps a half-filled form from being lost
// to a stray click. hideConfirm makes it a plain viewer: one button (cancelLabel, e.g. "Close").
const ConfirmModal = ({ title, message, confirmLabel = 'Confirm', cancelLabel = 'Cancel', danger = false, onConfirm, onCancel, children,
                        formId, wide = false, confirmDisabled = false, closeOnBackdrop = true, hideConfirm = false }) => {
    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') onCancel(); };
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, [onCancel]);

    return (
        <div className="cm-backdrop" onClick={closeOnBackdrop ? onCancel : undefined}>
            <div className={`cm-dialog${wide ? ' cm-dialog-wide' : ''}`} onClick={e => e.stopPropagation()} role="dialog" aria-modal="true">
                <h2 className="cm-title">{title}</h2>
                {message && <p className="cm-message">{message}</p>}
                {children}
                <div className="cm-actions">
                    <button className="cm-btn-cancel" onClick={onCancel}>{cancelLabel}</button>
                    {!hideConfirm && (
                        <button className={`cm-btn-confirm${danger ? ' cm-btn-danger' : ''}`} disabled={confirmDisabled}
                            {...(formId ? { type: 'submit', form: formId } : { onClick: onConfirm })} autoFocus={!children}>
                            {confirmLabel}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
